module.exports = __webpack_public_path__ + "img/double-arrow-left.6fbf0e43.svg";